import React, { useState } from 'react'
import { Anchor, Modal, Table } from '@mantine/core'

const RankExplanation: React.FC = () => {
  const [opened, setOpened] = useState(false)

  const rows = [
    { rank: 'Rランク', column: '最終訪問日から経過日数', values: ['365日～', '91日～364日', '61日～90日', '31日～60日', '0日～30日'] },
    { rank: 'Rランク2', column: '最終紹介日から経過日数', values: ['365日～', '91日～364日', '61日～90日', '31日～60日', '0日～30日'] },
    { rank: 'Fランク1', column: '紹介ページ訪問数', values: ['1', '2', '3', '4～5', '6～'] },
    { rank: 'Fランク2', column: '紹介行動数', values: ['1', '2', '3', '4～5', '6～'] },
    { rank: 'Mランク', column: 'ゲストユーザー数', values: ['0', '1', '2～3', '4～5', '6～'] },
    { rank: 'Mランク2', column: 'ゲストCV数', values: ['0', '1', '2～3', '4～5', '6～'] },
    { rank: 'LTランク', column: '初回訪問日から経過日数', values: ['0日～30日', '31日～90日', '91日～180日', '181日～364日', '365日～'] },
  ]

  return (
    <>
      <Anchor fz={13} onClick={() => setOpened(true)} style={{ cursor: 'pointer' }}>
        ランクの定義
      </Anchor>
      <Modal opened={opened} onClose={() => setOpened(false)} title="ランクの定義" size="60%">
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>ランク</Table.Th>
              <Table.Th style={{ width: 200 }}>値</Table.Th>
              <Table.Th>1</Table.Th>
              <Table.Th>2</Table.Th>
              <Table.Th>3</Table.Th>
              <Table.Th>4</Table.Th>
              <Table.Th>5</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {rows.map((row) => (
              <Table.Tr key={row.rank}>
                <Table.Td>{row.rank}</Table.Td>
                <Table.Td>{row.column}</Table.Td>
                {row.values.map((value, index) => (
                  <Table.Td key={index}>{value}</Table.Td>
                ))}
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Modal>
    </>
  )
}

export default RankExplanation
